export var FormPanel;
(function (FormPanel) {
    FormPanel["Irrigation"] = "IrrigationForm";
    FormPanel["IrrigationWaterData"] = "IrrigationWaterData";
    FormPanel["Plot"] = "PlotForm";
    FormPanel["OrchardDetailsForm"] = "OrchardDetailsForm";
})(FormPanel || (FormPanel = {}));
